import React from "react";

export default function HeaderFarben() {
    return <>
        <div className="header-bgk">
            <div className="header-box bg-purple"></div>
            <div className="header-box bg-blue"></div>
            <div className="header-box bg-green"></div>
            <div className="header-box bg-yellow"></div>
            <div className="header-box bg-red"></div>
            <div className="header-box bg-pink"></div>
        </div>
    </>
}